
export function toJsonAndThrowOnError(apiCall) {
  return async function apiCallWithThrowOnError(...args) {
    const res = await apiCall(...args);
    const bodyText = await res.text();
    let bodyJson;
    try {
      bodyJson = JSON.parse(bodyText);
    } catch (e) {
      throw new Error(`Response body is not a valid JSON, url: ${res.url}, status: ${res.status}, body: ${bodyText}`);
    }
    if (res.ok) {
      return bodyJson;
    }
    throw bodyJson;
  };
}
